import { Component } from '@angular/core';
import { EventsModule } from '../../../../events/events.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-event-view-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    EventsModule,
  ],
  templateUrl: './event-view-dashboard-page.component.html',
  styleUrl: './event-view-dashboard-page.component.sass',
})
export class EventViewDashboardPageComponent { }
